export const alphaNumericWithoutSpaceRegex = /^[a-zA-Z0-9]+$/;

export const portInPhoneRegex = /^(08[\d]{8})$/;
